export type Lang = 'es' | 'en';

export const TRANSLATIONS: Record<Lang, Record<string, string>> = {
  es: {
    // Nav
    'nav.services': 'Servicios',
    'nav.portfolio': 'Portafolio',
    'nav.process': 'Proceso',
    'nav.about': 'Nosotros',
    'nav.contact': 'Contacto',

    // Hero
    'hero.tagline': 'Tecnología para hacer crecer tu negocio',
    'hero.title': 'Creamos la página web o la app que tu negocio necesita',
    'hero.subtitle':
      'Páginas web, tiendas en línea y aplicaciones móviles hechas a tu medida. Sin complicaciones, sin enredos técnicos y a un precio justo.',
    'hero.cta': 'Hablemos de tu proyecto',
    'hero.cta2': 'Ver nuestro trabajo',

    // Servicios
    'services.label': 'Servicios',
    'services.title': 'Lo que hacemos por ti',
    'services.web.title': 'Páginas web',
    'services.web.desc':
      'Tu negocio en internet con una página moderna, rápida y fácil de encontrar. La primera impresión que tus clientes merecen.',
    'services.mobile.title': 'Aplicaciones móviles',
    'services.mobile.desc':
      'Tu propia app en iPhone y Android para estar en el bolsillo de tus clientes todos los días.',
    'services.saas.title': 'Sistemas para tu negocio',
    'services.saas.desc':
      'Reservas, pedidos, pagos, membresías: convertimos en automático lo que hoy haces a mano.',
    'services.cloud.title': 'Acompañamiento continuo',
    'services.cloud.desc':
      'Nos encargamos de que todo funcione siempre. Tú te dedicas a tu negocio, nosotros a la tecnología.',

    // Portafolio
    'portfolio.label': 'Nuestro trabajo',
    'portfolio.title': 'Proyectos que hablan por nosotros',
    'portfolio.elapowerhouse.desc':
      'Plataforma de entrenamiento con app en iPhone y Android: clases en video, pagos en línea y comunidad.',
    'portfolio.genesis.desc':
      'Plataforma que le da a cada comunidad su propia app, con su marca y su estilo.',
    'portfolio.boutique.desc':
      'Página web con reservas en línea para un hotel boutique.',
    'portfolio.tecnividrios.desc':
      'Catálogo en línea y pedidos para un negocio de vidrios y vitrofusión.',
    'portfolio.visit': 'Visitar sitio',
    'tag.video': 'Clases en video',
    'tag.communities': 'Comunidades',
    'tag.bookings': 'Reservas',
    'tag.catalog': 'Catálogo',

    // Proceso
    'process.label': 'Proceso',
    'process.title': 'Cómo trabajamos',
    'process.step1.title': 'Te escuchamos',
    'process.step1.desc': 'Entendemos tu negocio, tus clientes y lo que realmente necesitas resolver.',
    'process.step2.title': 'Diseñamos contigo',
    'process.step2.desc': 'Definimos juntos cómo se verá y cómo funcionará, antes de construir.',
    'process.step3.title': 'Construimos',
    'process.step3.desc': 'Te mostramos avances constantes. Nada de esperar meses sin saber nada.',
    'process.step4.title': 'Lanzamos y te acompañamos',
    'process.step4.desc': 'Publicamos tu proyecto y seguimos a tu lado para que siempre funcione.',

    // Nosotros
    'about.label': 'Nosotros',
    'about.title': 'Tecnología de calidad, sin que sea un lujo',
    'about.desc':
      'Crescio nace de una convicción: las pequeñas empresas también merecen tecnología de primera. Te ayudamos a tener presencia digital profesional, a precio justo y explicado en tu idioma — sin términos raros ni letra pequeña.',

    // Contacto
    'contact.label': 'Contacto',
    'contact.title': 'Cuéntanos tu idea',
    'contact.name': 'Nombre',
    'contact.email': 'Correo electrónico',
    'contact.company': 'Empresa (opcional)',
    'contact.message': 'Mensaje',
    'contact.send': 'Enviar mensaje',
    'contact.sending': 'Enviando...',
    'contact.success': 'Mensaje enviado. Te contactaremos pronto.',
    'contact.error': 'No se pudo enviar. Intenta de nuevo o escríbenos por WhatsApp.',
    'contact.required': 'Este campo es obligatorio.',
    'contact.invalidEmail': 'Ingresa un correo válido.',

    // Footer
    'footer.rights': 'Todos los derechos reservados.',
    'footer.privacy': 'Política de privacidad',

    // Cookie banner
    'cookie.message': 'Usamos cookies propias para analizar visitas y recordar tus preferencias. Puedes aceptar o rechazar su uso. Más información en nuestra ',
    'cookie.policy': 'Política de privacidad',
    'cookie.accept': 'Aceptar',
    'cookie.reject': 'Rechazar',

    // Admin
    'admin.title': 'Estadísticas de visitas',
    'admin.email': 'Correo electrónico',
    'admin.password': 'Contraseña',
    'admin.enter': 'Entrar',
    'admin.total': 'Visitas totales',
    'admin.byRef': 'Por origen',
    'admin.byCountry': 'Por país',
    'admin.byDay': 'Por día',
    'admin.range30': 'Últimos 30 días',
    'admin.loading': 'Cargando...',
    'admin.logout': 'Salir',
    'admin.changePassword': 'Cambiar contraseña',
    'admin.currentPassword': 'Contraseña actual',
    'admin.newPassword': 'Nueva contraseña',
    'admin.passwordChanged': 'Contraseña actualizada correctamente.',
    'admin.save': 'Guardar',
  },
  en: {
    // Nav
    'nav.services': 'Services',
    'nav.portfolio': 'Portfolio',
    'nav.process': 'Process',
    'nav.about': 'About',
    'nav.contact': 'Contact',

    // Hero
    'hero.tagline': 'Technology that grows your business',
    'hero.title': 'We create the website or app your business needs',
    'hero.subtitle':
      'Websites, online stores and mobile apps made just for you. No complications, no tech jargon, at a fair price.',
    'hero.cta': "Let's talk about your project",
    'hero.cta2': 'See our work',

    // Services
    'services.label': 'Services',
    'services.title': 'What we do for you',
    'services.web.title': 'Websites',
    'services.web.desc':
      'Your business online with a modern, fast, easy-to-find page. The first impression your customers deserve.',
    'services.mobile.title': 'Mobile apps',
    'services.mobile.desc':
      "Your own app on iPhone and Android, right in your customers' pocket every day.",
    'services.saas.title': 'Systems for your business',
    'services.saas.desc':
      'Bookings, orders, payments, memberships: we automate what you do by hand today.',
    'services.cloud.title': 'Ongoing support',
    'services.cloud.desc':
      'We make sure everything keeps working. You focus on your business, we handle the technology.',

    // Portfolio
    'portfolio.label': 'Our work',
    'portfolio.title': 'Projects that speak for us',
    'portfolio.elapowerhouse.desc':
      'Training platform with iPhone and Android app: video classes, online payments and community.',
    'portfolio.genesis.desc':
      'Platform that gives every community its own app, with its own brand and style.',
    'portfolio.boutique.desc':
      'Website with online bookings for a boutique hotel.',
    'portfolio.tecnividrios.desc':
      'Online catalog and orders for a glass and glass-art business.',
    'portfolio.visit': 'Visit site',
    'tag.video': 'Video classes',
    'tag.communities': 'Communities',
    'tag.bookings': 'Bookings',
    'tag.catalog': 'Catalog',

    // Process
    'process.label': 'Process',
    'process.title': 'How we work',
    'process.step1.title': 'We listen',
    'process.step1.desc': 'We get to know your business, your customers and what you really need.',
    'process.step2.title': 'We design with you',
    'process.step2.desc': 'Together we define how it will look and work, before building.',
    'process.step3.title': 'We build',
    'process.step3.desc': 'You see constant progress. No waiting months in the dark.',
    'process.step4.title': 'We launch and stay with you',
    'process.step4.desc': 'We publish your project and stay by your side to keep it running.',

    // About
    'about.label': 'About us',
    'about.title': 'Quality technology, without the luxury price',
    'about.desc':
      'Crescio was born from one conviction: small businesses deserve first-class technology too. We help you build a professional digital presence, at a fair price, explained in plain language — no strange terms, no fine print.',

    // Contact
    'contact.label': 'Contact',
    'contact.title': 'Tell us your idea',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.company': 'Company (optional)',
    'contact.message': 'Message',
    'contact.send': 'Send message',
    'contact.sending': 'Sending...',
    'contact.success': 'Message sent. We will get back to you soon.',
    'contact.error': 'Could not send. Try again or reach us on WhatsApp.',
    'contact.required': 'This field is required.',
    'contact.invalidEmail': 'Enter a valid email.',

    // Footer
    'footer.rights': 'All rights reserved.',
    'footer.privacy': 'Privacy policy',

    // Cookie banner
    'cookie.message': 'We use first-party cookies to analyze visits and remember your preferences. You can accept or reject their use. Learn more in our ',
    'cookie.policy': 'Privacy policy',
    'cookie.accept': 'Accept',
    'cookie.reject': 'Reject',

    // Admin
    'admin.title': 'Visit statistics',
    'admin.email': 'Email',
    'admin.password': 'Password',
    'admin.enter': 'Enter',
    'admin.total': 'Total visits',
    'admin.byRef': 'By source',
    'admin.byCountry': 'By country',
    'admin.byDay': 'By day',
    'admin.range30': 'Last 30 days',
    'admin.loading': 'Loading...',
    'admin.logout': 'Log out',
    'admin.changePassword': 'Change password',
    'admin.currentPassword': 'Current password',
    'admin.newPassword': 'New password',
    'admin.passwordChanged': 'Password updated successfully.',
    'admin.save': 'Save',
  },
};
